import { FormattedMessage, IntlShape } from "react-intl";

import { ItemsInnerTypeEnum, ProjectRole, TenantRole } from "@nens/rana/api-v1";

////// Translatable texts as JSX elements

export const cancelButtonText = <FormattedMessage id="button.cancel" defaultMessage="Cancel" />;

////// Translatable texts as strings
export const typeHereString = (intl: IntlShape) =>
  intl.formatMessage({
    id: "type_here",
    defaultMessage: "Type here",
  });

export const nameColumnString = (intl: IntlShape) =>
  intl.formatMessage({ id: "column.name", defaultMessage: "Name" });

export const fileNameColumnString = (intl: IntlShape) =>
  intl.formatMessage({ id: "column.filename", defaultMessage: "Filename" });

export const fileTypeString = (intl: IntlShape, type: ItemsInnerTypeEnum | undefined) => {
  switch (type) {
    case "file":
      return intl.formatMessage({ id: "file_type.file", defaultMessage: "file" });
    case "directory":
      return intl.formatMessage({ id: "file_type.directory", defaultMessage: "folder" });
    default:
      return intl.formatMessage({ id: "file_type.unknown", defaultMessage: "unknown" });
  }
};

type RoleMessage = Record<TenantRole | ProjectRole, { id: string; defaultMessage: string }>;

const roleStringMap: RoleMessage = {
  administrator: { id: "role.administrator", defaultMessage: "Administrator" },
  guest: { id: "role.guest", defaultMessage: "Guest" },
  member: { id: "role.member", defaultMessage: "Member" },
  collaborator: { id: "role.collaborator", defaultMessage: "Collaborator" },
  visitor: { id: "role.visitor", defaultMessage: "Visitor" },
};
export const userRoleString = (intl: IntlShape, role: TenantRole | ProjectRole) => {
  return intl.formatMessage(roleStringMap[role]);
};

const roleDescriptionStringMap: RoleMessage = {
  administrator: {
    id: "role.administrator.description",
    defaultMessage: "Full access to manage settings, users, and organisational resources.",
  },
  guest: {
    id: "role.guest.description",
    defaultMessage: "Temporary user with limited access to organisational features.",
  },
  member: {
    id: "role.member.description",
    defaultMessage: "Standard user with access to member-level resources and activities.",
  },
  collaborator: {
    id: "role.collaborator.description",
    defaultMessage:
      "Has full access to project resources, but cannot add other collaborators to the project.",
  },
  visitor: {
    id: "role.visitor.description",
    defaultMessage: "Only has viewing access to a project.",
  },
};
export const userRoleDescriptionString = (intl: IntlShape, role: TenantRole | ProjectRole) => {
  return intl.formatMessage(roleDescriptionStringMap[role]);
};
